// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"070a1615","977":"acfad54b"}[chunkId] + ".chunk.js";
};